class RuleLogic {
    ruleType = 'logic'

    static options = [
        {
            value: 'OR',
            label: 'OR',
        },
        {
            value: 'AND',
            label: 'AND',
        },
    ]

    constructor(logic = 'OR') {
        this.logic = logic
    }

    static clone(ruleLogic) {
        return new RuleLogic(ruleLogic.logic)
    }

    toJSON() {
        return {
            ruleType: this.ruleType,
            logic: this.logic,
        }
    }
}

export default RuleLogic
